var map = {
	"./black/kongxian2.png": "vbOm",
	"./blue/kongxian2.png": "H5wn",
	"./white/kongxian2.png": "o/9m"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6kXR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/kongxian2\.png$
// module id = 6kXR
// module chunks = 24